import ApiService from "@/common/api.service";

export const UserFacilitiesService = {
    create(params) {
        return ApiService.post("Facilities/add", params);
    },
    update(slug, params) {
        return ApiService.update("Facilities", slug, params);
    },
    async getLocationByType(locationType, locationId) {
        let location = await ApiService.get("location/" + locationType + "/" + locationId);
        return location.data ? location.data.data : []
    },
    async getWoredas() {
        return ApiService.get("/woredas");
    },
};
